/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unnecessary-condition -- error.response can be undefined at runtime */
import * as Sentry from '@sentry/nextjs'
import { AxiosError, isAxiosError } from 'axios'
import { ZodError } from 'zod'

import { ErrorApi, isErrorApi } from '@src/context/Shared/domain/ErrorApi.type'
import i18next from '@src/i18n/config'

export function getGenericRequestErrorMessage(): string {
  return String(i18next.t('errors:GENERIC.REQUEST_ERROR'))
}

const getErrorMessage = (error: AxiosError | ZodError | Error, fallbackMessage?: string) => {
  let errorMessage = ''
  if (isAxiosError(error) && isErrorApi(error.response?.data.errors)) {
    errorMessage = (error.response?.data.errors as Array<ErrorApi>)
      .map((ele) => {
        const source = ele.source
        const errorCode = ele.errorCode
        const message = ele.message
        const text = i18next.exists(`errors:${source}.${errorCode}`)
          ? i18next.t(`errors:${source}.${errorCode}`, message, { d: message })
          : (fallbackMessage ?? ele.defaultMessage)
        const requestId = typeof ele.requestId === 'string' && ele.requestId.length > 0 ? ele.requestId : undefined
        const textSafe = typeof text === 'string' ? text : String(text)
        return requestId !== undefined ? `${textSafe} - ${requestId}` : textSafe
      })
      .join(' ')
  } else if (fallbackMessage) {
    errorMessage = fallbackMessage
  } else if (isAxiosError(error)) {
    errorMessage = 'InternalServerError'
  } else {
    errorMessage = 'ZodError'
  }
  return errorMessage
}

export function handleCommonErrors(error: AxiosError | ZodError | Error, fallbackMessage?: string) {
  Sentry.captureException(error)
  const errorMessage = getErrorMessage(error, fallbackMessage)
  return new Error(errorMessage)
}

export function getApiErrorMessage(error: unknown) {
  const genericMessage = getGenericRequestErrorMessage()

  if (isAxiosError(error)) {
    return handleCommonErrors(error, genericMessage).message
  }

  if (error instanceof Error && error.message.length > 0) {
    return error.message
  }

  return genericMessage
}
